import { fmtMoneyFull } from "./money";
// Radha — drafts a legal-notice letter from account/invoice data (same idea
// as useDunning's dunningBody(), one tier up). This is TEXT ONLY — there is
// no legitimate API to "send" a legal notice through; a real one goes out via
// an advocate, registered post, or email, using whatever the AR/legal team
// copies from here.
export function legalNoticeText(input: {
  tenantLegalName: string; tenantGstin: string | null;
  debtorName: string; outstanding: number; daysPastDue: number;
  invoiceRefs?: string[];
}): string {
  const { tenantLegalName, tenantGstin, debtorName, outstanding, daysPastDue, invoiceRefs } = input;
  const amt = fmtMoneyFull(outstanding);
  const today = new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  const refs = invoiceRefs?.length ? `against invoice(s) ${invoiceRefs.join(", ")} ` : "";

  return `LEGAL NOTICE

Date: ${today}

To,
${debtorName}

From,
${tenantLegalName}${tenantGstin ? ` (GSTIN: ${tenantGstin})` : ""}

Subject: Notice for recovery of outstanding dues of ${amt}

Dear Sir/Madam,

Under instructions from and on behalf of my client, ${tenantLegalName}, I am to state as follows:

1. That an amount of ${amt} is due and payable by you to my client ${refs}for goods/services duly supplied and accepted, and the same has remained outstanding for ${daysPastDue} days as of the date of this notice.

2. That despite repeated reminders and requests, you have failed and neglected to clear the said outstanding amount.

3. That you are hereby called upon, through this notice, to pay the said sum of ${amt} to my client within 15 (fifteen) days from the date of receipt of this notice, failing which my client shall be constrained to initiate appropriate legal proceedings against you, including but not limited to proceedings under the Micro, Small and Medium Enterprises Development Act, 2006 (if applicable), the Negotiable Instruments Act, 1881, and/or the Insolvency and Bankruptcy Code, 2016, entirely at your risk, cost, and consequences.

4. That this notice is issued without prejudice to any other rights and remedies available to my client under law, all of which are expressly reserved.

Please treat this as final and act accordingly.

Yours faithfully,
For ${tenantLegalName}

---
This is a system-drafted letter. It must be reviewed by your advocate and issued on their letterhead before being sent — it is not, by itself, a validly served legal notice.`;
}
